import React, { ReactElement } from 'react'
import { Alert, Box } from '@ally/metronome-ui'

// Fix for CC ONLY to keep heading/body inline
const bodyCopy = (lob?: string): string | ReactElement => {
  if (lob === 'CC') {
    return "We can't show these accounts right now. We're working to have things back up as soon as possible. Try again later."
  }
  return "We're working to have things back up as soon as possible. Try again later."
}

export const PartialOutageNotice: React.FC<{ lob?: string }> = ({
  lob,
}): ReactElement => {
  return (
    <Box mb="sm" data-testid={`${lob}-outage-card`}>
      <Alert
        variant="error"
        heading={lob === 'CC' ? '' : "We can't show these accounts right now."}
        body={bodyCopy(lob)}
      />
    </Box>
  )
}
